import { WSFilter } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { usePayeeFilterOptions } from "../../../../Payees/hooks/usePayeeFilterOptions";
import { PayablesFilterKey, PayablesVisibleFilters } from "./types";

export function useBuildConfig(
  visibleFilters?: PayablesVisibleFilters
): WSFilter[] {
  const payeeOptions = usePayeeFilterOptions();

  return useMemo((): WSFilter[] => {
    const config: WSFilter[] = [];

    config.push({
      title: "Contractor",
      name: "payeeId",
      type: "select",
      apiOptions: payeeOptions
    });

    config.push({
      title: "Due date",
      name: "dueDateRange",
      type: "daterange",
      titleInLabel: true,
      options: ["all", "pastWeek", "pastMonth", "yearToDate", "custom"]
    });

    config.push({
      title: "Paid date",
      name: "paidDateRange",
      type: "daterange",
      titleInLabel: true,
      options: ["all", "pastWeek", "pastMonth", "yearToDate", "custom"]
    });

    config.push({
      title: "Opened date",
      name: "openedDateRange",
      type: "daterange",
      titleInLabel: true,
      options: ["all", "pastWeek", "pastMonth", "yearToDate", "custom"]
    });

    if (!visibleFilters) {
      return config;
    }

    return config.filter(
      f => visibleFilters[f.name as PayablesFilterKey] === true
    );
  }, [payeeOptions, visibleFilters]);
}
